<template>
  <div>
    <div class="d-flex align-center">
      <back-btn class="mr-3" />
      <h4 class="ml-2 title-page">
        {{ warehouse.warehouseName }} / {{ warehouse.column
        }}{{ warehouse.row }}
      </h4>
    </div>
    <div class="admin_container">
      <!-- <div class="text-right d-flex justify-space-between mb-5"></div> -->
      <div>
        <custom-input-text
          class="user_input no-margin"
          style="max-width: 400px"
          clearable
          :placeholder="$t('productName')"
          v-model="nameFilterProduct"
          @input="filterWarehouseProduct"
        />
      </div>
      <warehouse-stillage-view
        :data="boardData"
        :warehouseName="warehouse.warehouseName"
        @update="getBoard"
      />
    </div>
  </div>
</template>

<script>
import WarehouseStillageView from "@/components/warehouse/StillageView";
import { debounce, getQueryByKey } from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";
import { BoxService } from "@/services/BoxService.js";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants.js";

export default {
  components: { BackBtn, WarehouseStillageView },
  props: {
    id: {},
    columnId: {},
    cellId: {},
  },
  data() {
    return {
      nameFilterProduct: null,
      boardData: {
        columns: [],
        boards: [],
        rows: [],
      },
      warehouse: {
        warehouseName: null,
        column: null,
        row: null,
      },
    };
  },
  methods: {
    filterWarehouseProduct: debounce(async function () {
      await this.getBoard();
      await this.$router.replace({
        query: { productName: this.nameFilterProduct },
      });
    }, 300),
    async getBoard() {
      try {
        const { cellId } = this;
        const {
          data: { data },
        } = await this.$http.get("stillage/board", {
          params: { cellId, term: this.nameFilterProduct },
        });
        const boxService = new BoxService(DEFAULT_STILLAGE_BOX_SIZE);
        this.boardData = {
          ...boxService.parseData(data),
          id: this.id,
        };
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async warehouseStillageName() {
      try {
        const {
          data: { data },
        } = await this.$http.get("stillage/info-by-cell", {
          params: {
            cellId: this.cellId,
          },
        });
        if (data) {
          this.warehouse = getQueryByKey(this.warehouse, data);
        }
      } catch (err) {
        this.setResponseError({ error: err });
      }
    },
  },
  async created() {
    if (this.$route.query.productName) {
      this.nameFilterProduct = this.$route.query.productName;
    }
    this.showLoading();
    await this.getBoard();
    await this.warehouseStillageName();
    this.clearLoading();
  },
};
</script>
